import React, { useEffect } from 'react'
import ReactDOM from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { router } from './router'
import { loadConfigFromS3, getCurrentConfig } from './constants/configLoader'
import { initApiKey, isAuthenticated } from './services/authService'

// 스타일 로드
import './styles/common.css'
import './index.css'

// S3 설정 파일의 URL
const CONFIG_S3_URL = import.meta.env.CONFIG_S3_URL

console.log('=== 환경 변수 디버깅 ===');
console.log('CONFIG_S3_URL:', CONFIG_S3_URL);
console.log('API_URL:', import.meta.env.API_URL);
console.log('MODE:', import.meta.env.MODE);
console.log('=== 디버깅 종료 ===');

console.log('Init - CONFIG_S3_URL - 1:', CONFIG_S3_URL)

// API 키 초기화 시도 (로그인된 사용자만)
if (isAuthenticated()) {
  console.log('로그인된 사용자를 위한 API 키 초기화 시도...');
  initApiKey()
    .then(apiKey => {
      console.log('API 키 초기화 성공:', apiKey ? apiKey.substring(0, 10) + '...' : '키 없음');
    })
    .catch(error => {
      console.error('API 키 초기화 실패:', error.message);
      // 초기화 실패 시 추가 조치가 필요하면 여기에 구현
    });
}

// 앱 초기화 시 S3에서 설정 로드 (최우선 적용)
if (CONFIG_S3_URL) {
  console.log('Init - CONFIG_S3_URL - 2:', CONFIG_S3_URL)
  console.log('🚀 앱 시작: S3에서 설정 불러오기 시작 (최우선 적용)...', CONFIG_S3_URL)
  // 앱 초기화 시에는 강제 로드(forceReload=true)로 항상 최신 설정 가져오기
  loadConfigFromS3(CONFIG_S3_URL, true)
    .then(config => {
      console.log('✅ S3 설정 로드 완료! 현재 적용된 설정:', JSON.stringify({
        APPLICATION_START_DATE: config.APPLICATION_START_DATE,
        APPLICATION_CLOSE_DATE: config.APPLICATION_CLOSE_DATE
      }, null, 2))
    })
    .catch(error => {
      console.error('❌ S3 설정 로드 실패, 대체 설정 사용:', error)
      console.log('📝 현재 사용 중인 설정:', JSON.stringify({
        APPLICATION_START_DATE: getCurrentConfig().APPLICATION_START_DATE,
        APPLICATION_CLOSE_DATE: getCurrentConfig().APPLICATION_CLOSE_DATE
      }, null, 2))
    })
} else {
  console.log('⚠️ S3 URL이 제공되지 않았습니다. 로컬 설정을 사용합니다.')
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
)
